<div
  [ngClass]="[
    formGroup.controls['fileUpload'].errors &&
    (formGroup.controls['fileUpload'].dirty ||
      formGroup.controls['fileUpload'].touched)
      ? 'has-error'
      : '',
    isRequired ? 'valid file-uploader-wrap' : 'file-uploader-wrap'
  ]"
>
  <!-- <label class="block"> {{label}} &nbsp;

  </label> -->
  <div *ngIf="files && files.length <= 0" class="pos-relativE inline-block">
    <!-- <button class="btn btn-file"> إضافة ملف
      <i class="fa fa-upload" aria-hidden="true"></i>
    </button> -->
    <!-- <div class="form-group"><label class="mb-3" for="text"> وصف أعمال الامتياز (منتجات أو خدمات) </label><input class="form-control ng-dirty ng-touched ng-invalid" formcontrolname="workDescription" id="descriptionText" placeholder=" أدخل الملاحظات " type="text" ng-reflect-name="workDescription"></div> -->
    <div>
      <input
        #fileUpload
        multiple
        max="{{ noOfFiles }}"
        type="file"
        [accept]="acceptedExtensions"
        class="input-file"
        name="file"
        id="fileUpload"
        (change)="postFile($event.target.files)"
        (blur)="ValidateisRequired()"
      />
      <label class="custom-file-label form-control" for="fileUpload">
        {{
          fileUpload.value
            ? getFileName(fileUpload.value)
            : ("Global.AttachmentChooseFIle" | translate)
        }}
      </label>
      <span [ngClass]="{'admin-upload-button': this.isAdmin, 'upload-button': !isAdmin}">
        <span class="icon-upload"></span>
      </span>
    </div>
    <br />
  </div>

  <div *ngIf="isAddToDb && files.length > 0">
    <div
      class="request-summary--container show-attashment__container"
      style="padding: 5px 10px !important; height: 50px; overflow: hidden"
      *ngFor="let file of files; let i = index"
    >
      <div class="row">
        <div class="col-2 pt-3">
          <img
            style="position: relative; bottom: 4px"
            src="./assets/images/post.svg"
          />
        </div>
        <div class="col-8">
          <h6
            (click)="showFile(file.publicId)"
            class="pt-3"
            style="cursor: pointer"
          >
            {{ file.fileName }}
          </h6>
        </div>
        <div class="col-2 pt-3">
          <span
            (click)="deleteFile(file.publicId)"
            class="text-danger font-bold"
            style="cursor: pointer"
            >{{ "Global.AttachmentDelete" | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- <ul class="file-list" *ngIf="isAddToDb">
      <li *ngFor="let file of files let i = index" class="file-name">
        <a class="name" href="javascript:void(0);" (click)="showFile(file.publicId)" target="_blank">{{file.fileName}}</a>
        <a class="delete" href="javascript:void(0)" (click)="deleteFile(file.publicId)">
          <i class="fa fa-times " aria-hidden="true"> حذف</i>
        </a>
      </li>
    </ul> -->

  <ul class="file-list" *ngIf="!isAddToDb && localFileNames.length > 1">
    <li *ngFor="let name of localFileNames; let i = index">
      <span class="name"> {{ name }}</span>
    </li>
  </ul>

  <ul class="file-list" *ngIf="!isAddToDb && localFileNames.length == 1">
    <li *ngFor="let name of localFileNames; let i = index">
      <span class="name"> {{ name }}</span>

      <a
        class="delete"
        *ngIf="name"
        href="javascript:void(0)"
        (click)="deleteLocalFiles()"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
      </a>
    </li>
  </ul>
</div>
<div *ngIf="uploadedFiles <= 0" class="feadback">
  <div>
    <span *ngIf="!ValidateFileExtension()" style="color: #b3b3b3">
      {{ "Global.AttachmentExtensionsAllowed" | translate }}
      <label *ngFor="let extenstion of extensions">
        &nbsp;{{ extenstion.Name }}
        {{ "Global.AttachmentMaxSize" | translate }} {{ extenstion.Size }}
      </label>
    </span>
    <span *ngIf="noOfFiles > 1" style="color: #b3b3b3">
      <br />
      <label> يسمح اختيار اكثر من ملف </label>
    </span>

    <a
      class="delete pull-right"
      style="color: #c30400"
      *ngIf="localFileNames.length > 1"
      href="javascript:void(0)"
      (click)="deleteLocalFiles()"
    >
      <i class="fa fa-times" aria-hidden="true"></i>&nbsp; حذف الكل
    </a>
  </div>
  <div
    *ngIf="
      isRequired &&
      formGroup.controls['fileUpload'].errors &&
      (formGroup.controls['fileUpload'].dirty ||
        formGroup.controls['fileUpload'].touched)
    "
    class="text-danger"
  >
    {{ requiredMsg | translate }}
  </div>
  <div class="text-danger" *ngIf="!ValidateFileExtension()">
    {{ "Global.AttachmentExtensionNotValid" | translate }}
  </div>
  <div class="text-danger" *ngIf="!ValidateisValidFileSize()">
    {{ "Global.AttachmentMaxSizeNotValid" | translate }}
  </div>
  <div class="text-danger" *ngIf="!ValidateisValidFileName()">
    {{ "Global.AttachmentNameNotValid" | translate }}
  </div>
  <div class="text-danger" *ngIf="ValidateisHarmfulExtension()">
    {{ "Global.AttachmentHarmfulExtension" | translate }}
  </div>
</div>
